// Название товара для сравнения дублей — как norm_product_name на бэке
// (backend/app/routers/products.py): без регистра, «ё» = «е», пробелы схлопнуты.
export const normProductName = (v) => (v || '').toLowerCase().replace(/ё/g, 'е').split(/\s+/).filter(Boolean).join(' ');
